module.exports = __webpack_public_path__ + "img/icon361.9f125d53.png";